var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBadgeSocial = function SvgIconBadgeSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_badge_social_svg__a",
    width: "133.3%",
    height: "133.3%",
    x: "-16.7%",
    y: "-16.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F3A1C2",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    filter: "url(#icon_badge_social_svg__a)",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29 16.971c-1.182.203-2.41-.684-2.41-2.045v-.609A6.084 6.084 0 0 1 2 8.345v-.127C2 4.784 4.771 2 8.193 2h4.614C16.23 2 19 4.784 19 8.218c0 .715-.12 1.402-.337 2.043A4.915 4.915 0 0 1 22 14.91a4.915 4.915 0 0 1-4.12 4.846v.81c0 1.192-1.386 1.862-2.326 1.126l-2.41-1.88a4.43 4.43 0 0 1-3.855-2.842m8.385-4.915a6.15 6.15 0 0 1-4.844 2.378l-1.783 1.445a2.43 2.43 0 0 0 2.386 1.95h.048c.229 0 .47.08.65.227l1.748 1.357v-.507c0-.595.481-1.077 1.072-1.077h.12A2.924 2.924 0 0 0 20 14.911a2.915 2.915 0 0 0-2.325-2.855m-5.23.37a.9.9 0 0 0-.565.202l-2.904 2.346c-.036.032-.096.004-.096-.048V13.24a1 1 0 0 0-.049-.263.8.8 0 0 0-.192-.311.8.8 0 0 0-.579-.241c-2.24 0-4.06-1.827-4.06-4.08v-.128A4.2 4.2 0 0 1 8.193 4.01h4.614A4.2 4.2 0 0 1 17 8.218a4.2 4.2 0 0 1-4.193 4.208z"
  })))));
};
export default SvgIconBadgeSocial;